import { createTheme } from "@mui/material/styles";

// One look for every MUI control in the app: the bank's green, sentence-case
// buttons, rounded corners.
const theme = createTheme({
  palette: {
    primary: { main: "#127C43", dark: "#0f6a39", contrastText: "#fff" },
    secondary: { main: "#3D4F58" },
    success: { main: "#127C43" },
    background: { default: "#ffffff" },
  },
  shape: { borderRadius: 8 },
  typography: {
    button: { textTransform: "none", fontWeight: 700 },
  },
  components: {
    // thin, quiet scrollbars everywhere (item strip, wide tables, menu)
    MuiCssBaseline: {
      styleOverrides: {
        "*": { scrollbarWidth: "thin", scrollbarColor: "#c3cbc6 transparent" },
        "*::-webkit-scrollbar": { width: 6, height: 6 },
        "*::-webkit-scrollbar-track": { background: "transparent" },
        "*::-webkit-scrollbar-thumb": { backgroundColor: "#c3cbc6", borderRadius: 6 },
        "*::-webkit-scrollbar-thumb:hover": { backgroundColor: "#9aa59f" },
      },
    },
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiTableCell: { styleOverrides: { head: { fontWeight: 800 } } },
  },
});

export default theme;
